// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__3ZOYG","title":"style_title__3pLIZ","rows":"style_rows__20Uzm"};